module.exports = function() {
	return new Worker(__webpack_public_path__ + "fca9329439875d8ec1e2.jobs.wrkr.js");
};